
import { useDispatchStoreAction } from '~/mixins/DispatchStoreAction'

export default {
  mixins: [
    useDispatchStoreAction({
      action: 'cart/applyVoucher',
    }),
  ],

  data() {
    return {
      code: '',
    }
  },

  methods: {
    async applyVoucher() {
      try {
        await this.dispatchStoreAction(this.code, {
          silentOnSuccess: true,
          silentOnError: true,
        })
        this.code = ''
        this.$refs.observer.reset()
      } catch (error) {
        if (error.response?.status === 422) {
          if (error.response.data.code === 'voucher_user_required') {
            this.$toast.show(
              this.$t('vouchers.must-be-authenticated-for-appling')
            )
          } else {
            this.$toast.error(this.$t('vouchers.voucher-not-valid'))
          }
        }
      }
    },
  },
}
